import { render, staticRenderFns } from "./publicityList.vue?vue&type=template&id=0916c91d&scoped=true&"
import script from "./publicityList.vue?vue&type=script&lang=js&"
export * from "./publicityList.vue?vue&type=script&lang=js&"
import style0 from "./publicityList.vue?vue&type=style&index=0&id=0916c91d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0916c91d",
  null
  
)

export default component.exports